import { createReducer } from '@reduxjs/toolkit';
import { hide, show } from './actions';

type LoaderState = {
    value: boolean;
};

const initialState: LoaderState = {
    value: false,
};

export const loaderReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(show, (state) => {
            state.value = true;
        })
        .addCase(hide, (state) => {
            state.value = false;
        });
});
